ScrollReveal().reveal('.feature-row__text', {
  opacity: 0.5,
  duration: 1600,
  origin: 'bottom',
  distance: '200px',
});

ScrollReveal().reveal('#FeatureRowImageWrapper-162373436247baa629', {
  duration: 1000,
  scale: 1.5,
  opacity: 0,
});

ScrollReveal().reveal('#FeatureRowImageWrapper-16237344177f9d26b2', {
  duration: 1000,
  scale: 1.5,
  opacity: 0,
});

ScrollReveal().reveal('#FeatureRowImageWrapper-16237344668cb558ff', {
  duration: 1000,
  scale: 1.5,
  opacity: 0,
});

ScrollReveal().reveal('#shopify-section-1623734952cd311f8c .big_text', {
  duration: 1600,
  scale: 3,
});

ScrollReveal().reveal('.grid--view-items', {
  opacity: 0.5,
  duration: 1600,
  origin: 'right',
  distance: '200px',
});

ScrollReveal().reveal('#shopify-section-1619680854012a9911', {
  opacity: 0.5,
  duration: 1600,
  origin: 'bottom',
  distance: '200px',
});

ScrollReveal().reveal('#shopify-section-16237353606af572dd .page-width', {
  duration: 1600,
  scale: 0.1,
});

ScrollReveal().reveal('#shopify-section-16203509896610a5ff', {
  opacity: 0.5,
  duration: 1600,
  origin: 'bottom',
  distance: '200px',
});

ScrollReveal().reveal('#shopify-section-quotes', {
  opacity: 0.5,
  duration: 1600,
  origin: 'bottom',
  distance: '200px',
});

ScrollReveal().reveal('.product-single', {
  duration: 3000,
});

ScrollReveal().reveal('#shopify-section-16237353606af572dd', {
  duration: 1600,
});
